import styled from 'styled-components';

export const LogoWrapper = styled.div`
    height: 38px;
    position: relative;
    z-index: 10;

    svg {
        filter: ${({ theme }) => (theme.mode === 'dark' ? 'brightness(0) invert(1)' : 'none')};
    }
`;
